import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { INumericValue } from '../../interfaces/numeric-value.interface';
import { OnOffPlugin } from '../on-off/on-off.plugin';

const CURRENT_LEVEL_MIN = 0;
const CURRENT_LEVEL_MAX = 254;

export class LevelControlServerPlugin extends SmartenitPlugin
  implements INumericValue {

  public getReportableAttrs() {
    return ['CurrentLevel'];
  }
  public setValue(value: number, attribute?: string): any {
    value = Math.round(value * 2.55);

    const payload = {
      Level: value,
      TransitionTime: 65535
    };

    const delay: number = this.getReadAttributeDelay() || 500;
    setTimeout(() => {
      this.readDeviceOnOffStatus();
    }, delay);

    return this.executeMethod(
      this.componentId,
      this.processorName,
      'MoveToLevelWOnOff',
      payload
    );
  }

  public getUnit(attribute?: string): string {
    return '%';
  }

  public getValue(attribute?: string): number {
    return this.state;
  }

  public getConditionAttribute(): string {
    return 'CurrentLevel';
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string {
    return 'MoveToLevelWOnOff';
  }

  public getConditionOptions(): any {
    return null;
  }

  public getEffectOptions(): any {
    return null;
  }

  public getEffectPayload(value: any, attribute?: string, method?: string) {
    return {
      Level: this.getRawValue(value, attribute, method),
      TransitionTime: 0
    };
  }

  public valueFromEffectPayload(
    payload: any,
    attribute?: string,
    method?: string
  ) {
    const value = payload && payload.Level ? payload.Level : 50;
    return this.getProcessedValue(value, attribute, method);
  }

  public getResponderAttribute(): string {
    return 'CurrentLevel';
  }

  public getResponderMethod(): string | null {
    return null;
  }

  public getStatusPayload(): any {
    return ['CurrentLevel'];
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'CurrentLevel') {
      const response = message && message.data && message.data.response;

      const value = Number(response.value);
      this.state = value / 2.55;

      this._onUpdate.next({ state: this.state });
    }

    return this.state;
  }

  public readDeviceOnOffStatus() {
    Object.keys(this.device.plugins)
      .map((key) => this.device.plugins[key])
      .filter((plugin) => plugin instanceof OnOffPlugin)
      .forEach((plugin: OnOffPlugin) => {
        plugin.device.getStatus(
          plugin.componentId,
          plugin.processorName,
          plugin.getStatusPayload(),
          'cached=false'
        );
      });
  }

  public getRawValue(
    value: number,
    attribute?: string,
    method?: string
  ): number {
    if (!attribute || attribute === 'CurrentLevel') {
      return this.pluginUtilsService.getValueFromPercentage(
        value,
        CURRENT_LEVEL_MIN,
        CURRENT_LEVEL_MAX
      );
    } else {
      return value;
    }
  }

  public getProcessedValue(value: any, attribute?: string, method?: string) {
    if (
      (method && method.toLowerCase() === 'movetolevelwonoff') ||
      !attribute ||
      attribute === 'CurrentLevel'
    ) {
      return this.pluginUtilsService.getValueToPercentage(
        value,
        CURRENT_LEVEL_MIN,
        CURRENT_LEVEL_MAX
      );
    } else {
      return value;
    }
  }
}
